<template>
  <vue-navigation-bar :options="navbarOptions" />
</template>

<script>
  export default {
    data () {
      return {
        navbarOptions: {
          elementId: 'main-navbar',
          isUsingVueRouter: true,
          mobileBreakpoint: 992,
          brandImagePath: './',
          brandImageAltText: 'brand-image',
          collapseButtonOpenColor: '#661c23',
          collapseButtonCloseColor: '#661c23',
          showBrandImageInMobilePopup: true,
          ariaLabelMainNav: 'Main Navigation',
          tooltipAnimationType: 'shift-away',
          menuOptionsLeft: [
            {
              type: 'link',
              text: 'Templates',
              iconLeft: '<i class="mdi mdi-file-document-outline"></i>',
              path: { name: 'DashboardPage' },
            },
            {
              type: 'link',
              text: 'Production',
              iconLeft: '<i class="mdi mdi-factory"></i>',
              path: { name: 'ProductionPage' },
            },
            {
              type: 'link',
              text: 'Jobs',
              iconLeft: '<i class="mdi mdi-progress-clock"></i>',
              path: { name: 'NexrenderPage' },
            },
          ],
        },
      }
    },
    computed: {
      isSuper () {
        return this.$store.getters.isSuperadmin
      },
    },
    watch: {
      '$route' (to, from) {
        // this.generateMenu(to)
      },
    },
    created () {
      if (this.isSuper) {
        this.navbarOptions.menuOptionsLeft.push(
          {
            type: 'link',
            text: 'Settings',
            iconLeft: '<i class="mdi mdi-cog"></i>',
            path: { name: 'SettingsPage' },
          },
        )
      }
      // this.generateMenu()
    },
    methods: {
      /*      generateMenu () {
        this.navbarOptions.menuOptionsLeft = []
        this.navbarOptions.menuOptionsLeft.push(this.dashboardMenu)
        this.navbarOptions.menuOptionsLeft.push(this.nexrenderMenu)
      }, */
    },
  }
</script>

<style lang="scss">
.vnb {
  &__menu-options {
    &__option {
      &__link {
        &:focus {
          outline: none;
          border: 1px solid none;
        }
        &:hover {
          color: #0081ff;
          .vnb__menu-options__option__arrow {
            fill: #0081ff;
          }
        }

        &__icon {
          svg {
            fill: #0081ff !important;
          }
        }
      }
    }
  }

  &__sub-menu-options {
    &__option {
      &__link {
        &:focus {
          outline: none;
          border: 1px solid none;
        }
        color: #000 !important;
        &:hover {
          color: #0081ff !important;
        }
      }
    }
  }
}

.vnb__collapse-button {
  &:focus {
    border: 1px solid none;
    outline: none;
  }
  &:after {
    content: "\F035C";
    font-size: 25px;
    font-weight: 600;
    font-family: "Material Design Icons",serif;
  }
  svg {
    display: none !important;
  }
}

.vnb__popup {
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: scroll !important;
  .vnb__popup__top__close-button {
    &:focus {
      border: 1px solid none;
      outline: none;
    }
    top: 20px;
    right: -33px;
    svg {
      fill: #000 !important;
    }
  }
}
.vnb__sub-menu-options__option {
  max-height: 400px;
  overflow-y:auto;
}
</style>
